import { ReconciledSaleItem } from "./PartialPayment";

export const isNewPaymentValid = (isRefund: boolean, reconciledSaleItems: ReconciledSaleItem[]) => {

    if (isRefund) {
        reconciledSaleItems.forEach(rsi => {
            const payment = roundTo2DP(rsi.payment);
            const maxRefund = roundTo2DP(rsi.maxRefund);

            if (0 > payment || payment > maxRefund) { return false; }
        });

        return true;
    }

    reconciledSaleItems.forEach(rsi => {
        const payment = roundTo2DP(rsi.payment);
        const outstandingAmount = roundTo2DP(rsi.outstandingAmount);

        if (0 > payment || payment > outstandingAmount) {
            return false;
        }
    });

    return true;
}

const roundTo2DP = (value: number) => {
    return Math.round(value * 100) / 100;
}

export const paymentDue = (amount: number | null, outstanding: number) => {
    return amount && (roundTo2DP(Number(amount)) <= 0 || roundTo2DP(Number(amount)) > roundTo2DP(outstanding));
}